import { createContext, useContext } from 'react';
import type { ChatSelectionContext, OpenChatOptions } from '../utils/chat-text-context';

export type MainAreaView =
  | 'suggestions'
  | 'comments'
  | 'chat'
  | 'chapters'
  | 'analysis'
  | 'storylines'
  | 'scenes'
  | 'characters'
  | 'locations'
  | 'technicalSheet'
  | 'export'
  | 'share'
  | 'versionHistory'
  | 'stats'
  | 'settings'
  | null;

export type RightSidebarContextType = {
  toggleSidebar: () => void;
  open: boolean;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  showSuggestions: () => void;
  openSuggestions: () => void;
  showComments: () => void;
  openComments: () => void;
  showChat: () => void;
  openChat: (options?: OpenChatOptions) => void;
  chatSelectionContext: ChatSelectionContext | null;
  clearChatSelection: () => void;
  showChapters: () => void;
  showAnalysis: () => void;
  showStorylines: () => void;
  showScenes: () => void;
  showCharacters: () => void;
  showLocations: () => void;
  showTechnicalSheet: () => void;
  showExport: () => void;
  showShare: () => void;
  showVersionHistory: () => void;
  showStats: () => void;
  showSettings: () => void;
  navigateToChat: (threadId: string, messageId?: string) => void;
  chatNavigateThreadId: string | null;
  chatNavigateMessageId: string | null;
  chatFocusRequest: number;
  clearChatNavigation: () => void;
  activeView: 'suggestions' | 'comments' | 'chat' | 'chapters' | 'analysis' | 'storylines' | 'scenes' | 'characters' | 'locations' | 'technicalSheet' | 'export' | 'share' | 'versionHistory' | 'stats' | 'settings' | null;
  activeMainAreaView: MainAreaView;
  collapseSidebar: () => void;
  closeChat: () => void;
};

export const RightSidebarContext = createContext<RightSidebarContextType | null>(null);

export const useRightSidebar = (): RightSidebarContextType => {
  const context = useContext(RightSidebarContext);
  if (!context) {
    throw new Error('useRightSidebar must be used within EditorRightSidebarProvider');
  }
  return context;
};
